import React from 'react';
import { Trans } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const colors = ['#38C477', '#B7F2CA', '#EEEEEE', '#FFAC99', '#F2543D'];

const HeatMapScale = () => (
  <>
    <Row className="justify-content-center justify-content-md-end p-0">
      <Col xs={12} xl={6} className="p-0">
        <Row className="p-0">
          {colors.map((color) => (
            <Col className="justify-content-center d-flex p-0" key={color}>
              <div className="border rounded-2 w-75 w-md-100 shadow" style={{ height: '25px', background: color }} />
            </Col>
          ))}

        </Row>
      </Col>
    </Row>
    <Row className="justify-content-center justify-content-md-end">
      <Col
        xs={12}
        xl={6}
        className="d-flex justify-content-between p-0 px-md-2"
      >
        <Form.Text>
          <Trans style={{ color: '#38C477' }}>Positive</Trans>
        </Form.Text>
        <Form.Text>
          <Trans style={{ color: '#EEEEEE' }}>%</Trans>
        </Form.Text>
        <Form.Text>
          <Trans style={{ color: '#F2543D' }}>Negative</Trans>
        </Form.Text>
      </Col>
    </Row>
  </>
);

export default HeatMapScale;
